(function () {
  // Product page (>= 1024px): the image card and the info card are always the same height, and the info card is sticky.
  //   --pdp-h = max(the image card as a square, the info card's own content height), written on .f-pdp; both cards use it (theme.css).
  //   If the info card is taller than what fits under the fixed header, .f-pdp gets .is-static (no sticky, the card scrolls with the page).
  // Below 1024px nothing is measured and the layout is the plain stacked one. Nothing here writes to the store.
  var pdp = document.querySelector('.f-pdp');
  if (!pdp) return;
  var stage = pdp.querySelector('.f-gallery__stage');
  var box = pdp.querySelector('.f-pdp__buybox');
  if (!box) return;
  var mq = window.matchMedia('(min-width: 1024px)');
  var TOP = 72;       // fixed header 56px + 16px
  var BOTTOM = 16;
  var queued = false;

  function measure() {
    queued = false;
    if (!mq.matches) {
      pdp.style.removeProperty('--pdp-h');
      pdp.classList.remove('is-static');
      return;
    }
    // natural heights: let both cards size themselves, read them, then lock them to the larger one
    pdp.style.removeProperty('--pdp-h');
    var square = stage ? stage.getBoundingClientRect().width : 0;   // the image card is 1:1 when it has no explicit height
    var content = box.getBoundingClientRect().height;
    var h = Math.ceil(Math.max(square, content));
    pdp.style.setProperty('--pdp-h', h + 'px');
    pdp.classList.toggle('is-static', h + TOP + BOTTOM > window.innerHeight);
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.setTimeout(measure, 30);   // (not requestAnimationFrame: it is paused in background tabs, which would leave stale heights)
  }

  measure();
  window.addEventListener('resize', queue);
  if (mq.addEventListener) mq.addEventListener('change', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  window.addEventListener('load', queue);

  // content changes inside the info card (size change, low-stock line, status text) re-measure
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { if (mq.matches) queue(); });
    Array.prototype.forEach.call(box.children, function (c) { ro.observe(c); });
    ro.observe(pdp);
  }
  if (window.MutationObserver) {
    new MutationObserver(queue).observe(box, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  }
})();
